import { apiClient } from './apiClient'
import type {
  NotificationPreferenceUpdate,
  NotificationPreferencesData,
} from '../types/notifications'

interface ApiResponse<T> {
  success: boolean
  data?: T
  error?: string
}

function parseError(err: unknown, fallback: string): Error {
  const ax = err as { response?: { data?: { error?: string } }; message?: string }
  return new Error(ax.response?.data?.error || ax.message || fallback)
}

export async function fetchUserNotificationPreferences(): Promise<NotificationPreferencesData> {
  try {
    const res = await apiClient.get<ApiResponse<NotificationPreferencesData>>(
      '/account/notification-preferences'
    )
    return res.data.data ?? { types: [], emailDigestEnabled: true }
  } catch (e) {
    throw parseError(e, 'Kunne ikke hente notifikationsindstillinger')
  }
}

export async function updateUserNotificationPreferences(
  preferences: NotificationPreferenceUpdate[]
): Promise<NotificationPreferencesData> {
  try {
    const res = await apiClient.patch<ApiResponse<NotificationPreferencesData>>(
      '/account/notification-preferences',
      { preferences }
    )
    if (!res.data.success || !res.data.data) {
      throw new Error(res.data.error || 'Kunne ikke gemme indstillinger')
    }
    return res.data.data
  } catch (e) {
    throw parseError(e, 'Kunne ikke gemme notifikationsindstillinger')
  }
}

export async function updateEmailDigestEnabled(
  enabled: boolean
): Promise<NotificationPreferencesData> {
  try {
    const res = await apiClient.patch<ApiResponse<NotificationPreferencesData>>(
      '/account/notification-preferences',
      { emailDigestEnabled: enabled }
    )
    if (!res.data.success || !res.data.data) {
      throw new Error(res.data.error || 'Kunne ikke gemme indstillinger')
    }
    return res.data.data
  } catch (e) {
    throw parseError(e, 'Kunne ikke gemme e-mail-indstilling')
  }
}
